<template>
  <div class="notice">
    <el-tabs v-model="activeCode" @tab-click="handleClick">
      <el-tab-pane name="1">
        <div slot="label">
          <el-badge :value="noticeDataList[0] ? noticeDataList[0].length : 0" :hidden="!noticeDataList[0] || noticeDataList[0].length === 0" :max="99">
            <span>{{ $t('home.pa') }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <el-tab-pane name="2">
        <div slot="label">
          <el-badge :value="noticeDataList[1] ? noticeDataList[1].length : 0" :hidden="!noticeDataList[1] || noticeDataList[1].length === 0" :max="99">
            <span>{{ $t('home.r') }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <el-tab-pane name="3">
        <div slot="label">
          <el-badge :value="noticeDataList[2] ? noticeDataList[2].length : 0" :hidden="!noticeDataList[2] || noticeDataList[2].length === 0" :max="99">
            <span>{{ $t('home.pf') }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <el-tab-pane name="4">
        <div slot="label">
          <el-badge :value="noticeDataList[3] ? noticeDataList[3].length : 0" :hidden="!noticeDataList[3] || noticeDataList[3].length === 0" :max="99">
            <span>{{ $t('home.pv') }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
      <el-tab-pane name="5">
        <div slot="label">
          <el-badge :value="noticeDataList[4] ? noticeDataList[4].length : 0" :hidden="!noticeDataList[4] || noticeDataList[4].length === 0" :max="99">
            <span>{{ $t('home.vip') }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
    </el-tabs>
    <ul class="notice_content" v-show="noticeCurrentList.length > 0">
      <li v-for="(item, index) in noticeCurrentList" :key="index" @click="pageJump(item)">
        <span class="text" :title="item.activityName">{{ index + 1 }}，{{ item.activityName }}</span>
        <span class="date" v-show="activeCode !== '5'">{{ item.applyTime }}</span>
        <span class="nodeView" v-show="activeCode === '5'" @click.stop="viewProcess(item)">查看核销节点</span>
      </li>
    </ul>
    <div class="nullImage" v-show="noticeCurrentList.length < 1">
      <img :src="nullImageUrl" alt="">
      <p>{{ $t('home.empty') }}</p>
    </div>
    <approvalProcessDialog
      :activity-code="currentActivityCode"
      :approval-dialog-visible="processlDialogVisible"
      @dialogCloseHandle="processCloseHandle"
    />
  </div>
</template>
<script>
import { notice } from '../../service';
import nullImage from '@/assets/images/contentNull.png';
import approvalProcessDialog from '@/views/activitieList/component/activityQuery/approvalProcessDialog';
import { QUARTER_PERIODS } from '@/utils/constants';

export default {
  data () {
    return {
      activeCode: '1',
      noticeCurrentList: [],
      nullImageUrl: nullImage,
      processlDialogVisible: false,
      currentActivityCode: ''
    };
  },
  props: {
    noticeDataList: {
      type: Array,
      default: () => {
        return [[], [], [], [], []];
      }
    }
  },
  components: {
    approvalProcessDialog
  },
  computed: {},
  methods: {
    viewProcess (data) {
      this.currentActivityCode = data.activityCode;
      this.processlDialogVisible = true;
    },
    processCloseHandle () {
      this.processlDialogVisible = false;
    },
    pageJump (data) {
      if (data.annualPlan) {
        let path = '';
        if (this.activeCode === '2') {
          path = data.annual ? '/annualPlanApplication' : '/quarterlyFilingApplication';
        } else {
          path = data.annual ? '/annualPlanDetails' : '/quarterlyFilingDetails';
        }
        let query = {};
        if (data.annual) {
          query.id = data.id;
        } else {
          const quarter = QUARTER_PERIODS.find(item => item.label === data.quarter).key;
          query = {
            year: data.year,
            quarter,
            annualPlanId: data.annualPlanId,
            id: data.id
          };
        }
        this.$router.push({
          path,
          query
        });
      } else {
        let path = '/activityDetails';
        if (data.reportType) {
          path = data.reportType === '1' ? '/regionReportDetails' : '/industryReportDetails';
        } else {
          path = data.submitType === 'report_submit' ? '/reportDetails' : '/activityDetails';
        }
        this.$router.push({
          path,
          query: {
            activityCode: data.activityCode,
            metaActive: '/home'
          }
        });
      }
    },
    setNoticeDefault (val) {
      this.noticeCurrentList = val;
    },
    handleClick (val) {
      this.activeCode = val.name;
      this.noticeCurrentList = this.noticeDataList[val.name - 1];
      // this.getPendingApproval(this.activeCode);
    },
    getPendingApproval (data) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        approvalStat: data || 2
      };
      notice.getPendingApproval(params).then(res => {
        if (res.status === '200') {
          this.noticeCurrentList = res.data;
        }
      });
    }
  },
  mounted () {
    // this.getPendingApproval();
  }
};
</script>
<style lang="scss" scoped>
.notice {
  width: 50%;
  background: #ffffff;

  ::v-deep.el-tabs {
    .el-tabs__header {
      margin-bottom: 8px;

      .el-tabs__nav-wrap {
        padding: 0 16px;
        .el-tabs__nav {
          .el-tabs__item {
            height: 60px;
            line-height: 60px;
            color: #909399;
            padding: 0 13px;

            .el-badge .el-badge__content {
              top: 12px;
            }
          }
          .is-active {
            color: #202932;
          }
        }
      }

      .el-tabs__nav-wrap::after {
        background: #ebeef5;
        height: 1px;
      }
    }
  }
  ::v-deep .el-tabs__nav-prev,::v-deep .el-tabs__nav-next{
    height: 60px;
    line-height: 60px;
  }
  .nullImage {
    width: 276px;
    margin: 50px auto;
    text-align: center;
    padding-left: 34px;
    box-sizing: content-box;
    > img {
      width: 100%;
    }

    > p {
      line-height: 24px;
    }
  }

  .notice_content {
    max-height: 230px;
    margin: 16px;
    padding: 16px;
    border: 1px solid #EBEEF5;
    overflow-y: auto;
    /*滚动条整体样式*/
    &::-webkit-scrollbar {
      width: 7px;
      height: 10px;
    }

    /*滚动条滑块*/
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      cursor: pointer;
      background: rgba(144, 147, 153, .3);

      &:hover {
        background: rgba(144, 147, 153, .5);
      }
    }

    /*滚动条轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ffffff;
    }

    > li {
      cursor: pointer;

      & ~ li {
        margin-top: 20px;
      }

      &:after {
        content: "";
        display: block;
        clear: both;
      }

      > .text {
        width: 360px;
        float: left;
        color: #606266;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        @media screen and (max-width: 1440px) {
          max-width: 310px;
        }
        @media screen and (max-width: 1350px) {
          max-width: 300px;
        }
        @media screen and (max-width: 1330px) {
          max-width: 260px;
        }
        @media screen and (max-width: 1240px) {
          max-width: 200px;
        }
        @media screen and (max-width: 1140px) {
          max-width: 150px;
        }
      }

      > .date {
        float: right;
        color: #909399;
      }
      >.nodeView{
        float: right;
        color: #3384FE;
      }
    }
  }
}
</style>
